import { Component, OnInit } from '@angular/core';
import { MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { BreadcrumbItemModel } from 'src/app/RefModules/_metronic/partials/layout/subheader/_models/breadcrumb-item.model';

@Component({
    selector: 'app-management-sub-header',
    templateUrl: './management-sub-header.component.html',
    styleUrls: ['./management-sub-header.component.scss'],
    standalone: false
})
export class ManagementSubHeaderComponent {
    subheaderCSSClasses = '';
    subheaderContainerCSSClasses = '';
    subheaderMobileToggle = false;
    subheaderDisplayDesc = false;
    subheaderDisplayDaterangepicker = false;
    title$: Observable<string>;
    breadcrumbs$: Observable<BreadcrumbItemModel[]>;
    description$: Observable<string>;
    durationInSeconds = 5;
    horizontalPosition: MatSnackBarHorizontalPosition = 'start';
    verticalPosition: MatSnackBarVerticalPosition = 'bottom';

    imgSrc: string = '../../../../../../assets/media/logos/Administration-black.png';

    onMouseOver(): void {
        this.imgSrc = '../../../../../../assets/media/logos/Administration-yellow.png';
    }

    onMouseOut(): void {
        this.imgSrc = '../../../../../../assets/media/logos/Administration-black.png';
    }
}
